import { Stack } from "@mui/material";
import { Button } from "components/ButtonNew";
import { EnergyAnalysisEnergyInput } from "features/energy-analysis-dashboard/components/EnergyAnalysisEnergyInput";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useCrremSubset } from "../hooks/useCrremSubset";

type CrremSubsetInputProps = {
  disabled?: boolean;
  hideTitle?: boolean;
  projectId: string;
};

export const CrremSubsetInput = ({ disabled, hideTitle, projectId }: CrremSubsetInputProps) => {
  const { t } = useTranslation();
  const [confirming, setConfirming] = useState(false);
  const subset = useCrremSubset(projectId);
  const isBusy = disabled || subset.isBusy;
  return (
    <Stack className="w-full min-w-0 flex-col items-stretch gap-4">
      <EnergyAnalysisEnergyInput
        disabled={isBusy}
        hideTitle={hideTitle}
        hint={String(t("BuildingProfile.crremPathway.subset.hint"))}
        isUploading={subset.isUploading}
        onDownload={subset.downloadTemplate}
        onUpload={subset.uploadFile}
        title={String(t("BuildingProfile.crremPathway.subset.title"))}
      />
      {confirming ? (
        <Stack className="w-full flex-col items-stretch gap-2">
          <p className="font-ds-body-regular-sm text-lds-foreground-muted">
            {t("BuildingProfile.crremPathway.subset.revertConfirm")}
          </p>
          <Stack className="w-full justify-end gap-2">
            <Button disabled={subset.isReverting} onClick={() => setConfirming(false)} size="sm" variant="tertiary">
              {t("general.cancel")}
            </Button>
            <Button
              isLoading={subset.isReverting}
              onClick={() => {
                subset.revertOverrides(undefined, {
                  onSuccess: () => setConfirming(false),
                });
              }}
              size="sm"
              variant="primary"
            >
              {t("BuildingProfile.crremPathway.subset.revert")}
            </Button>
          </Stack>
        </Stack>
      ) : (
        <Button
          disabled={isBusy}
          onClick={() => setConfirming(true)}
          size="sm"
          startIconName="Return"
          variant="secondary"
        >
          {t("BuildingProfile.crremPathway.subset.revert")}
        </Button>
      )}
    </Stack>
  );
};
